export const DEFAULT_CACHE_GRACE_PERIOD = 15 * 60 * 1000; // 15 mins in millis
export const DEFAULT_NUMBER_OF_RECENTLY_USED = 8;
export const RECENTLY_USED_PREFIX = 'recently_';
export const SUPPORTED_ASSET_OBJECTS_TYPES = ['LANDING_PAGE', 'CTA', 'BLOG_POST', 'SITE_PAGE', 'AD_CAMPAIGN', 'AUTOMATION_PLATFORM_FLOW', 'CONTENT', 'SOCIAL_BROADCAST', 'MARKETING_EMAIL', 'WEB_INTERACTIVE'];